import { useSessionState } from "./use-session-state"

export const useIsAuthenticated = () => {
  return useSessionState((state) => state.isAuthenticated)
}

export const useSaveIsAuthenticated = () => {
  return useSessionState((state) => state.setIsAuthenticated)
}
